module.exports = __webpack_public_path__ + "static/bring-your-team-together-5ab111b04bc29f0d3b905d3289b1a859.png";